import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { PurchaseFormResponse } from '@Types/api/form';
import { parseDateTime } from '@Utils/transformDateTime';

interface FieldSourceProps {
  data: PurchaseFormResponse;
  findClassification: (classificationId: number) => string;
}

const fieldSource = ({
  data,
  findClassification,
}: FieldSourceProps): Array<{
  label: string;
  value: string | number | boolean;
}> => {
  const {
    approver,
    classificationId,
    statusId,
    reqNo,
    reqFromId,
    mrNo,
    group3Desc,
    reqDate,
    requiredOn,
    project,
  } = data;

  const source = {
    'PR No.': reqNo || EMPTY_FIELD_PLACEHOLDER,
    Status: statusId || EMPTY_FIELD_PLACEHOLDER,
    'Request From':
      (reqFromId && (reqFromId === 1 ? 'Buildsmart' : 'TBMS 2.0')) ||
      EMPTY_FIELD_PLACEHOLDER,
    'TBMS MR.No/ERP PR No.': mrNo || EMPTY_FIELD_PLACEHOLDER,
    'Material Group': group3Desc || EMPTY_FIELD_PLACEHOLDER,
    Classification:
      findClassification(classificationId) || EMPTY_FIELD_PLACEHOLDER,
    'Request Date': parseDateTime(reqDate) || EMPTY_FIELD_PLACEHOLDER,
    'Required Date': parseDateTime(requiredOn) || EMPTY_FIELD_PLACEHOLDER,
    'Store/Project': project || EMPTY_FIELD_PLACEHOLDER,
    'Purchase Officer': approver || EMPTY_FIELD_PLACEHOLDER,
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export default fieldSource;
